export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  // Solo lato server: inizializza token nel cookie
  if (process.server) {
    const defaultToken = config.graphqlApiKey

    const cookieDefault = useCookie('apollo:default.token', {
      maxAge: 60 * 60 * 24,
    })

    if (!cookieDefault.value) cookieDefault.value = defaultToken
  }

  // Gestiamo in modo differenziato il comportamento cookie - client - token per Server e Client
  nuxtApp.hook('apollo:auth', ({ token, client }) => {
    if (process.server) {
      if (client === 'default') token.value = config.graphqlApiKey
    }

    if (process.client) {
      const cookie = useCookie(`apollo:${client}.token`)
      token.value = cookie.value
    }
  })

  nuxtApp.hook('apollo:error', (error) => {
    console.error('Apollo error:', error)

    if (error.networkError) {
      console.error('Network error:', error.networkError)
      // Handle network errors (e.g., API down, timeout)
      console.error('A network error occurred. Please try again later.')
    }

    if (error.graphQLErrors?.length) {
      for (const graphQLError of error.graphQLErrors) {
        console.error('GraphQL error:', graphQLError)
        switch (graphQLError.extensions?.code) {
          case 'UNAUTHENTICATED':
            console.error('You are not authenticated. Please login again.')
            break
          case 'FORBIDDEN':
            console.error('You do not have permission to perform this action.')
            break
          case 'INTERNAL_SERVER_ERROR':
            console.error('A server error occurred. Please try again later.')
            break
          default:
            console.error(`Error: ${graphQLError.message}`)
        }
      }
    }
  })
})
